import {useState} from "react";

// Components


// Scss
import '../assets/css/partnerPortal/homepage.scss';
import '../assets/css/partnerPortal/welcome.scss';


function Title(props) {


  const [title] = useState(props.title);
  const [className] = useState(props.className);
  const [classNameText] = useState(props.classNameText);
  const [withoutLine] = useState(props.withoutLine);

  return (
    <>
      
      <div className={className}>
        <div className={"frameTitle " + classNameText}>{title}</div>
        {withoutLine ? "" : <div className="lineBlack mt-1"></div>}
      </div>
            
    </>
  );


}

export default Title;

